import { render, staticRenderFns } from "./scroller.vue?vue&type=template&id=735a1a04&scoped=true&"
import script from "./scroller.vue?vue&type=script&lang=js&"
export * from "./scroller.vue?vue&type=script&lang=js&"
import style0 from "./scroller.vue?vue&type=style&index=0&id=735a1a04&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "735a1a04",
  null
  
)

export default component.exports